// removed by extract-text-webpack-plugin
module.exports = {"method-wrapper":"payment-method-selector__method-wrapper__2V6d6","chevron-down-small-box":"payment-method-selector__chevron-down-small-box__2nc17","chevron-down-small-icon":"payment-method-selector__chevron-down-small-icon__2X_55","payment-method":"payment-method-selector__payment-method__1EG0H","picker-selector":"payment-method-selector__picker-selector__Wkvdy","suffix":"payment-method-selector__suffix__3gjsz","selector":"payment-method-selector__selector__3oSdo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rsvp_modal/payment-method-selector.scss
// module id = 1270
// module chunks = 1